(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nvs-tra-cuu-masothue"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[id^="MstLookup-"]');
  var root = roots[roots.length - 1];
  if (!root || root.getAttribute("data-mst-bound") === "1") return;
  root.setAttribute("data-mst-bound", "1");

  var $ = function (sel) { return root.querySelector(sel); };
  var HIST_KEY = "mst_basic_v1";
  var VI_MAP = {"á":"a","à":"a","ả":"a","ã":"a","ạ":"a","ă":"a","ắ":"a","ằ":"a","ẳ":"a","ẵ":"a","ặ":"a","â":"a","ấ":"a","ầ":"a","ẩ":"a","ẫ":"a","ậ":"a","é":"e","è":"e","ẻ":"e","ẽ":"e","ẹ":"e","ê":"e","ế":"e","ề":"e","ể":"e","ễ":"e","ệ":"e","í":"i","ì":"i","ỉ":"i","ĩ":"i","ị":"i","ó":"o","ò":"o","ỏ":"o","õ":"o","ọ":"o","ô":"o","ố":"o","ồ":"o","ổ":"o","ỗ":"o","ộ":"o","ơ":"o","ớ":"o","ờ":"o","ở":"o","ỡ":"o","ợ":"o","ú":"u","ù":"u","ủ":"u","ũ":"u","ụ":"u","ư":"u","ứ":"u","ừ":"u","ử":"u","ữ":"u","ự":"u","ý":"y","ỳ":"y","ỷ":"y","ỹ":"y","ỵ":"y","đ":"d"};

  function normalize(raw) {
    return String(raw || "").trim().replace(/\s+/g, "").replace(/[–—]/g, "-");
  }
  function isValidMst(mst) {
    return /^(?:\d{10}|\d{10}-\d{3})$/.test(mst);
  }
  function slugify(text) {
    return String(text || "").toLowerCase().split("").map(function (ch) {
      return VI_MAP[ch] || ch;
    }).join("").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  }
  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function money(n) {
    var num = Number(n);
    return Number.isFinite(num) ? new Intl.NumberFormat("vi-VN").format(num) : "";
  }
  function statusClass(text) {
    var t = (text || "").toLowerCase();
    if (t.indexOf("ngừng") >= 0 || t.indexOf("đóng") >= 0 || t.indexOf("không hoạt động") >= 0 || t === "inactive") return "bad";
    if (t.indexOf("chờ") >= 0 || t.indexOf("chưa") >= 0 || t.indexOf("xác minh") >= 0 || t.indexOf("đợi") >= 0) return "warn";
    if (t.indexOf("hoạt động") >= 0 || t === "active") return "ok";
    return "neutral";
  }
  function setMsg(text, err) {
    var el = $(".js-mst-msg");
    el.textContent = text || "";
    el.className = "js-mst-msg mst-msg" + (err ? " is-error" : "");
  }
  function field(label, value, extra) {
    if (!value) return "";
    return '<div class="mst-field ' + (extra || "") + '"><div class="mst-label">' + label + '</div><div class="mst-value">' + value + "</div></div>";
  }
  function loadHist() {
    try { return JSON.parse(localStorage.getItem(HIST_KEY) || "[]"); } catch (e) { return []; }
  }
  function renderHist() {
    var items = loadHist();
    $(".js-mst-hist").innerHTML = items.length
      ? items.map(function (x) {
          return '<div class="mst-hist-item" data-mst="' + x.mst + '"><div><div class="mst-mono">' + x.mst + '</div><div class="mst-meta">' + escapeHtml(x.name) + "</div></div><div class=\"mst-meta\">" + new Date(x.at).toLocaleString("vi-VN") + "</div></div>";
        }).join("")
      : '<div class="mst-meta">Chưa có lần tra cứu nào.</div>';
  }
  function saveHist(mst, name) {
    var items = loadHist().filter(function (x) { return x.mst !== mst; });
    items.unshift({ mst: mst, name: name, at: Date.now() });
    localStorage.setItem(HIST_KEY, JSON.stringify(items.slice(0, 8)));
    renderHist();
  }

  function fetchJson(url, timeout) {
    timeout = timeout || 10000;
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, timeout);
    return fetch(url, { signal: ctrl.signal, headers: { Accept: "application/json" } })
      .then(function (res) { return res.text().then(function (text) { return { ok: res.ok, text: text }; }); })
      .then(function (out) {
        var json = null;
        try { json = out.text ? JSON.parse(out.text) : null; } catch (e) {}
        return { ok: out.ok, json: json };
      })
      .catch(function () { return { ok: false, json: null }; })
      .then(function (v) { clearTimeout(t); return v; });
  }

  function fetchText(url, timeout) {
    timeout = timeout || 12000;
    var ctrl = new AbortController();
    var t = setTimeout(function () { ctrl.abort(); }, timeout);
    return fetch(url, { signal: ctrl.signal })
      .then(function (res) { return res.ok ? res.text() : ""; })
      .catch(function () { return ""; })
      .then(function (v) { clearTimeout(t); return v; });
  }

  function parseContacts(text) {
    if (!text) return {};
    var tel = text.match(/tel:(\+?\d[\d\s.-]{7,})/i);
    var mail = text.match(/mailto:([a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,})/i);
    var web = text.match(/\nWebsite\s*\n+\s*\[([^\]]+)\]/i);
    var phoneLine = text.match(/Điện thoại[^|\n]{0,40}\|\s*([^|\n]+)/i);
    var out = {};
    if (tel) out.phone = tel[1].replace(/\s+/g, " ").trim();
    else if (phoneLine) out.phone = phoneLine[1].replace(/Ẩn số điện thoại/gi, "").trim();
    if (mail) out.email = mail[1];
    if (web) out.website = web[1].replace(/^https?:\/\//, "");
    return out;
  }

  function lookupContacts(mst, name) {
    var slug = slugify(name);
    var urls = [
      "https://r.jina.ai/https://doanhnghiep.vn/dn/" + encodeURIComponent(mst),
      slug ? "https://r.jina.ai/https://masothue.com/" + encodeURIComponent(mst + "-" + slug) : "https://r.jina.ai/https://masothue.com/" + encodeURIComponent(mst)
    ];
    var merged = {};
    return urls.reduce(function (p, url) {
      return p.then(function () {
        if (merged.phone && merged.email) return merged;
        return fetchText(url).then(function (text) {
          var next = parseContacts(text);
          if (next.phone && !merged.phone) merged.phone = next.phone;
          if (next.email && !merged.email) merged.email = next.email;
          if (next.website && !merged.website) merged.website = next.website;
          return merged;
        });
      });
    }, Promise.resolve(merged));
  }

  function paint(mst, tax, firm, contacts) {
    contacts = contacts || {};
    var name = (tax && tax.name) || (firm && firm.name_vi) || "Không rõ tên";
    var statusText = (tax && tax.status) || (firm && (firm.status === "active" ? "Đang hoạt động" : firm.status)) || "Không rõ";
    $(".js-mst-name").textContent = name;
    $(".js-mst-aka").textContent = [firm && firm.name_en, tax && tax.internationalName, tax && tax.shortName, firm && firm.legal_form].filter(Boolean).filter(function (v, i, a) { return a.indexOf(v) === i; }).join(" · ");
    var st = $(".js-mst-status");
    st.textContent = statusText;
    st.className = "js-mst-status mst-status mst-status--" + statusClass(statusText);

    var phone = contacts.phone ? '<a href="tel:' + escapeHtml(contacts.phone) + '">' + escapeHtml(contacts.phone) + "</a>" : "";
    var email = contacts.email ? '<a href="mailto:' + escapeHtml(contacts.email) + '">' + escapeHtml(contacts.email) + "</a>" : "Chưa truy xuất được";
    var web = contacts.website ? '<a href="https://' + escapeHtml(contacts.website) + '" target="_blank" rel="noopener">' + escapeHtml(contacts.website) + "</a>" : "";

    $(".js-mst-fields").innerHTML = [
      field("Mã số thuế", '<span class="mst-mono">' + escapeHtml((tax && tax.id) || (firm && firm.mst) || mst) + "</span>"),
      field("Tình trạng hiện tại", escapeHtml(statusText)),
      field("Địa chỉ", escapeHtml((tax && tax.address) || (firm && firm.address_full) || ""), "is-full"),
      field("Người đại diện pháp luật", escapeHtml((firm && firm.legal_rep_name) || "Chưa truy xuất được")),
      field("Điện thoại doanh nghiệp", phone || "Chưa truy xuất được"),
      field("Email doanh nghiệp", email),
      field("Website", web),
      field("Ngày đăng ký", escapeHtml((firm && firm.registered_at) || "")),
      field("Vốn điều lệ", firm ? money(firm.charter_capital_vnd) : ""),
      field("Niêm yết", firm && firm.is_listed ? escapeHtml((firm.listed_ticker || "") + " (" + (firm.listed_exchange || "") + ")") : (firm ? "Không" : "")),
      field("Ngành chính", firm && firm.industry ? escapeHtml((firm.industry.code || "") + " — " + (firm.industry.name_vi || "")) : "", "is-full")
    ].join("");

    var rep = (firm && firm.legal_rep_name) || "người đại diện";
    $(".js-mst-note").innerHTML = (contacts.phone || contacts.email)
      ? "Liên hệ trên là <b>số điện thoại / email doanh nghiệp đã công bố</b>, không phải máy cá nhân của " + escapeHtml(rep) + "."
      : "Không lấy được SĐT/email công ty từ nguồn công khai. Họ tên đại diện: <b>" + escapeHtml(rep) + "</b>. SĐT cá nhân không được cơ quan đăng ký công bố.";

    $(".js-mst-masothue").href = "https://masothue.com/" + encodeURIComponent(mst);
    $(".js-mst-result").classList.remove("mst-hidden");
    saveHist(mst, name);
    window.__mstCopy = [
      "MST: " + ((tax && tax.id) || mst),
      "Tên: " + name,
      ((tax && tax.address) || (firm && firm.address_full)) ? ("Địa chỉ: " + ((tax && tax.address) || firm.address_full)) : "",
      firm && firm.legal_rep_name ? ("Đại diện: " + firm.legal_rep_name) : "",
      contacts.phone ? ("Điện thoại công ty: " + contacts.phone) : "",
      contacts.email ? ("Email DN: " + contacts.email) : ""
    ].filter(Boolean).join("\n");
  }

  function run(raw) {
    var mst = normalize(raw);
    var input = $(".js-mst-input");
    var btn = $(".js-mst-btn");
    input.value = mst;
    if (!mst) return setMsg("Nhập mã số thuế.", true);
    if (!isValidMst(mst)) return setMsg("MST gồm 10 số, hoặc 10 số-3 số với chi nhánh.", true);
    btn.disabled = true;
    btn.innerHTML = '<span class="mst-spinner"></span>Đang tra';
    setMsg("Đang lấy hồ sơ và trạng thái hiện tại...");

    Promise.all([
      fetchJson("https://api.vietqr.io/v2/business/" + encodeURIComponent(mst)),
      fetchJson("https://doanhnghiep.vn/api/v1/companies/" + encodeURIComponent(mst))
    ]).then(function (pair) {
      var taxRes = pair[0];
      var firmRes = pair[1];
      var tax = taxRes.json && taxRes.json.code === "00" ? taxRes.json.data : null;
      var firm = firmRes.ok && firmRes.json && firmRes.json.mst ? firmRes.json : null;
      if (!tax && !firm) {
        $(".js-mst-result").classList.add("mst-hidden");
        setMsg("Không tìm thấy doanh nghiệp, hoặc nguồn đang quá tải.", true);
        return;
      }
      paint(mst, tax, firm, {});
      setMsg("Đang tìm điện thoại / email công ty...");
      var name = (tax && tax.name) || (firm && firm.name_vi) || "";
      return lookupContacts(mst, name).then(function (contacts) {
        paint(mst, tax, firm, contacts);
        setMsg("");
      });
    }).catch(function () {
      $(".js-mst-result").classList.add("mst-hidden");
      setMsg("Không gọi được nguồn dữ liệu. Thử lại sau.", true);
    }).then(function () {
      btn.disabled = false;
      btn.textContent = "Tra cứu";
    });
  }

  $(".js-mst-form").addEventListener("submit", function (e) {
    e.preventDefault();
    run($(".js-mst-input").value);
  });
  $(".js-mst-hist").addEventListener("click", function (e) {
    var item = e.target.closest("[data-mst]");
    if (item) run(item.getAttribute("data-mst"));
  });
  $(".js-mst-clear").addEventListener("click", function () {
    localStorage.removeItem(HIST_KEY);
    renderHist();
  });
  $(".js-mst-copy").addEventListener("click", function () {
    if (!window.__mstCopy) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(window.__mstCopy).then(function () {
        $(".js-mst-copy").textContent = "Đã sao chép";
        setTimeout(function () { $(".js-mst-copy").textContent = "Sao chép thông tin cơ bản"; }, 1100);
      }).catch(function () { setMsg("Không sao chép được.", true); });
    } else {
      setMsg("Không sao chép được.", true);
    }
  });
  renderHist();
})();

  } catch(e) { console.error(e); }
})();
})();
